export const enum MutationTypes {

  // editor
  SET_ACTIVE_ELEMENT_ID_LIST = 'setActiveElementIdList',
  SET_HANDLE_ELEMENT_ID = 'setHandleElementId',
  SET_ACTIVE_GROUP_ELEMENT_ID = 'setActiveGroupElementId',
  SET_CANVAS_PERCENTAGE = 'setCanvasPercentage',
  SET_CANVAS_WIDTH = 'SET_CANVAS_WIDTH',
  SET_CANVAS_HEIGHT = 'SET_CANVAS_HEIGHT',
  SET_CANVAS_SCALE = 'setCanvasScale',
  SET_THUMBNAILS_FOCUS = 'setThumbnailsFocus',
  SET_EDITORAREA_FOCUS = 'setEditorAreaFocus',
  SET_COPY_STATE = 'setCopyState',
  SET_DISABLE_HOTKEYS_STATE = 'setDisableHotkeysState',
  SET_GRID_LINES_STATE = 'setGridLinesState',
  SET_CREATING_ELEMENT = 'setCreatingElement',
  SET_AVAILABLE_FONTS = 'setAvailableFonts',
  SET_TOOLBAR_STATE = 'setToolbarState',
  SET_CLIPING_IMAGE_ELEMENT_ID = 'setClipingImageElementId',
  SET_RICHTEXT_ATTRS = 'setRichTextAttrs',
  SET_SELECTED_TABLE_CELLS = 'setSelectedTableCells',
  SET_SCALING_STATE = 'setScalingState',
  SET_EDITING_SHAPE_ELEMENT_ID = 'setEditingShapeElementId',
  SET_EDITING_TEXT_ELEMENT_ID = 'setEditingTextElementId',
  SET_EDITING_RECT_ELEMENT_ID = 'setEditingRectElementId',
  SET_SCALING_COMMAND = 'setScalingCommand',
  SET_SLIDES_FONTS = 'setSlidesFonts',
  SET_SLIDES_FONTS_LIST = 'setSlidesFontsList',
  SET_SLIDES_USE_FONTS_LIST = 'setSliderUseFontsList',
  SET_EDITING_CLIP = 'setEditingClip',
  SET_HIDDEN_ELEMENT_ID_LIST = 'setHiddenElementIdList',
  
  // slides
  SET_TITLE = 'setTitle',
  SET_THEME = 'setTheme',
  SET_VIEWPORT_RATIO = 'setViewportRatio',
  SET_VIEWPORT_RATIO_WIDTH = 'SET_VIEWPORT_RATIO_WIDTH',
  SET_VIEWPORT_RATIO_WIDTHS = 'SET_VIEWPORT_RATIO_WIDTHS',
  SET_VIEWPORT_RATIO_TYPE = 'SET_VIEWPORT_RATIO_TYPE',
  SET_VIEWPORT_RATIO_HEIGHT = 'SET_VIEWPORT_RATIO_HEIGHT',
  SET_VIEWPORT_RATIO_HEIGHTS = 'SET_VIEWPORT_RATIO_HEIGHTS',
  SET_SLIDES = 'setSlides',
  SET_SLIDES_DATA = 'SET_SLIDES_DATA',
  SET_TEMPLATE_DATA = 'SET_TEMPLATE_DATA',
  SET_VIP_SHOW = 'SET_VIP_SHOW',
  SET_COPY_SHOW='SET_COPY_SHOW',
  ADD_SLIDE = 'addSlide',
  UPDATE_SLIDE = 'updateSlide',
  DELETE_SLIDE = 'deleteSlide',
  UPDATE_SLIDE_INDEX = 'updateSlideIndex',
  UPDATE_SELECTED_SLIDES_INDEX = 'updateSelectedSlidesIndex',
  ADD_ELEMENT = 'addElement',
  UPDATE_ELEMENT = 'updateElement',
  SET_SELECT_PANEL_STATE="setSelectPanelState",
  REMOVE_ELEMENT_PROPS = 'removeElementProps',
  SAVE_SPINNING = 'saveSpinning',
  SET_SCENCE = 'set_scence',
  SET_PREVIEW_URL = 'set_preview_url',
  // snapshot
  SET_SNAPSHOT_CURSOR = 'setSnapshotCursor',
  SET_SNAPSHOT_LENGTH = 'setSnapshotLength',

  // keyboard
  SET_CTRL_KEY_STATE = 'setCtrlKeyState',
  SET_SHIFT_KEY_STATE = 'setShiftKeyState',
  SET_SPACE_KEY_STATE = 'setSpaceKeyState',

  SET_CANVAS_DRAGGED = 'setCanvasDragged',
  // screen
  SET_SCREENING = 'setScreening',

  // layouts
  SET_LAYOUTS = 'layouts',
  SET_TEMP_STATE = 'setTempState',
  SET_LAY_STATE = 'setLayState',

  // handler
  SET_ELE_DRAWER_STATE = 'eleDrawerState',
  SET_ELE_THUMB_STATE = 'eleThumbState',
  SET_ELE_DRAWER_TYPE = 'eleDrawerType',
  SET_CRATED_DESIGN_MODAL_STATE = 'createDesignModalState',
  SET_TEMP_MODAL_STATE = 'tempModalState',
  SET_TAG_ALL_ELE_STATE = 'tagAllEleState',
  SET_IMAGES_MODAL_STATE = 'imagesModalState',
  ADD_GROUP_ELEMENT = 'add_group_element',

  // login
  SET_USER_INFO = 'setUserInfo',
  SET_LOGIN_MODAL_STATE = 'set_login_modal_state',
  SET_LOGIN_MODAL_TYPE = 'set_login_modal_type',

  // search
  SET_SEARCH_KEY = 'set_search_key',
  SET_SEARCH_TOTAL = 'set_search_total',
  SET_SEARCH_HISTORY = 'set_search_history',

  // publish
  PUBLISH_TEMPLATE_VISIBLE = 'publish_template_visible',
  PUBLISH_MATERIAL_VISIBLE = 'publish_material_visible',


  ALLOW_BACK = "ALLOW_BACK",
  SET_DWONLOAD_INDEX = 'SET_DWONLOAD_INDEX',

  // EFFECT
  SET_EFFECT_NUM = 'SET_EFFECT_NUM',
  SET_SAVE_TIME = "SET_SAVE_TIME",
  SET_VERTICAL_LINE = "SET_VERTICAL_LINE",
  SET_HORIZONTAL_LINE = "SET_HORIZONTAL_LINE",
  SET_HOTKEY = 'SET_HOTKEY',
  SET_EXPORTING_STATE = "SET_EXPORTING_STATE",
  SET_ISFRIST_SAVE = "SET_ISFRIST_SAVE",
  CREATE_CODEID_VALUE = "CREATE_CODEID_VALUE",
  SET_OPENMORE_VALUE = "SET_OPENMORE_VALUE",
  SET_VERSION_SHOW = "SET_VERSION_SHOW",
  SET_INVITE_INFO = "SET_INVITE_INFO",

  SET_EIDT_LIST = "SET_EIDT_LIST",
  SET_TOKEN = "SET_TOKEN",

  SET_SVG_SHOW = "SET_SVG_SHOW",
  SET_SVG_TYPE = "SET_SVG_TYPE",
  // mobile
  SET_M_PAGE_SHOW = "SET_M_PAGE_SHOW",
  SET_M_TEMPLATE_SHOW = "SET_M_TEMPLATE_SHOW",
  SET_M_MATERIAL_SHOW = "SET_M_MATERIAL_SHOW",
  SET_M_BACKGROUND_SHOW = "SET_M_BACKGROUND_SHOW",
  SET_M_USER_SHOW = "SET_M_USER_SHOW",
  SET_M_ADD_SHOW = "SET_M_ADD_SHOW",
  SET_M_IMAGES_SHOW = 'SET_M_IMAGES_SHOW'}






export const enum ActionTypes {
  INIT_SNAPSHOT_DATABASE = 'initSnapshotDatabase',
  ADD_SNAPSHOT = 'addSnapshot',
  UN_DO = 'undo',
  RE_DO = 'redo',
  SAVE_SLIDE = 'save_slide',
  SAVE_PREVIEW = "SAVE_PREVIEW",
}